import { Avatar, Timeline, Typography, Collapse } from 'antd'
import './style.scss'
const { Panel } = Collapse
export const ItineraryTimeline = ({ trip }) => {
  let events = []
  trip?.itineraries?.forEach((ev, index) => {
    ev['type'] = 'day'
    ev['dayNumber'] = index + 1
    events.push(ev)
    events = events.concat(ev.events)
  })
  if (events?.length > 0) {
    events.push({
      type: 'day',
      id: 'last-event',
      dayNumber: trip?.itineraries?.length + 1,
      title: 'End of event',
    })
  }
  return (
    <Timeline mode="left" className="timeline-view-container">
      {events?.map((itr) => {
        return itr?.type == 'day' ? (
          <Timeline.Item
            key={itr?.id}
            className="day-content"
            dot={
              <Avatar size={40} style={{ backgroundColor: '#20a39e' }}>
                {itr?.dayNumber}
              </Avatar>
            }
          >
            <Typography.Title level={4}>{itr?.title}</Typography.Title>
          </Timeline.Item>
        ) : (
          <Timeline.Item
            key={itr?.id}
            dot={<Avatar size={24} style={{ backgroundColor: '#20a39e' }} />}
          >
            <Collapse
              collapsible="header"
              defaultActiveKey={['1']}
              bordered={false}
              expandIconPosition="end"
            >
              <Panel
                header={
                  <>
                    {itr?.location && (
                      <Typography.Text level={4}>
                        <div>
                          {itr?.startTime && <span>{itr?.startTime}</span>}
                          {itr?.duration && (
                            <Typography.Text type="secondary">
                              {' '}
                              ({itr?.duration} {itr?.durationUnit})
                            </Typography.Text>
                          )}
                        </div>
                      </Typography.Text>
                    )}
                    <Typography.Title level={5}>{itr?.title}</Typography.Title>
                  </>
                }
                key="1"
              >
                <Typography.Text>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: itr?.description,
                    }}
                  />
                </Typography.Text>
              </Panel>
            </Collapse>
          </Timeline.Item>
        )
      })}
    </Timeline>
  )
}
